import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SupplierDomainConfirmDialogData {
  existingSuppliers: Array<{
    supplierId: number;
    companyName: string;
    emailAddress: string;
  }>;
  typedEmail: string;
  domain: string;
}

@Component({
  selector: 'supplier-domain-confirm-dialog-component',
  templateUrl: './supplier-domain-confirm-dialog.component.html',
  styleUrls: ['./supplier-domain-confirm-dialog.component.css']
})
export class SupplierDomainConfirmDialogComponent {
  selectedSupplierId: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<SupplierDomainConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SupplierDomainConfirmDialogData
  ) {
    if (data.existingSuppliers && data.existingSuppliers.length > 0) {
      this.selectedSupplierId = data.existingSuppliers[0].supplierId;
    }
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    if (this.selectedSupplierId == null) {
      return;
    }
    const chosen = this.data.existingSuppliers.find(
      (s) => s.supplierId === this.selectedSupplierId
    );
    this.dialogRef.close({
      confirmed: true,
      supplierId: this.selectedSupplierId,
      companyName: chosen ? chosen.companyName : ''
    });
  }
}
